import React, { ErrorInfo } from 'react';

// Components
import ErrorBoundary from '../../../components/error/errorBoundary/ErrorBoundary';
import ToolbarPopupTool from './ToolbarPopupTool';
import ToolbarPopup from './toolbarPopup/ToolbarPopup';
import DefaultErrorRenderer from '../../../components/error/errorBoundary/DefaultErrorRenderer';

// Types
import { PopupIds } from '../../../components/popupPanel/popupConstants';

import './ToolbarErrorBoundary.scss';

const getErrorMessage = (error: Error) => `Error rendering toolbar: ${error.toString()}`;

const getRollbarErrorDetails = (error: Error, info: ErrorInfo, props: any) => ({
    boardId: props.currentBoardId,
    stack: info.componentStack,
});

const ToolbarErrorRendererPopup = () => {
    return (
        <ToolbarPopup
            popupId={PopupIds.TOOLBAR_ERROR_INFO}
            className="ToolbarErrorRendererPopupPanel"
            buttonSelector=".ToolbarErrorRenderer .Tool .icon"
        >
            <DefaultErrorRenderer heading="Something went wrong in the Toolbar" />
        </ToolbarPopup>
    );
};

const ToolbarErrorRendererToolIcon = () => <div>⚠️</div>;

const ToolbarErrorRenderer = () => (
    <div className="ToolbarErrorRenderer">
        <h2>Toolbar Error</h2>

        <ToolbarPopupTool
            name="More info"
            toolName="More info"
            popupId={PopupIds.TOOLBAR_ERROR_INFO}
            icon="error"
            IconComponent={ToolbarErrorRendererToolIcon}
            PopupComponent={ToolbarErrorRendererPopup}
        />
    </div>
);

const ToolbarErrorBoundary = (props: object) => (
    <ErrorBoundary
        {...props}
        ErrorRenderer={ToolbarErrorRenderer}
        getErrorMessage={getErrorMessage}
        getRollbarErrorDetails={getRollbarErrorDetails}
    />
);

export default ToolbarErrorBoundary;
